import { Col, List, Row } from "antd";
import React from "react";

function attendanceTemplate(currentEducation, attendees, educators) {
    console.log(currentEducation);
	return (
		<>
            <h3>Popis sudionika za edukaciju</h3>
            <p>{currentEducation.eduName}</p>
            <h4>Organizator: </h4> <p>{currentEducation.orgName}</p>
			<Row>
				<Col span={12}>
					<List
						header="Edukatori"
						dataSource={attendees}
						renderItem={(item) => (
							<List.Item>
								<List.Item.Meta description={item.label} />
							</List.Item>
						)}
					/>
				</Col>
				<Col span={12}>
					<List
						header="Polaznici"
						dataSource={educators}
						renderItem={(item) => (
							<List.Item>
								<List.Item.Meta description={item.label} />
							</List.Item>
						)}
					/>
				</Col>
			</Row>
		</>
	);
}

export default attendanceTemplate;
